import { render } from "./loader.vue?vue&type=template&id=56ff35f2&scoped=true"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=56ff35f2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ff35f2"]])

export default __exports__